import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sqrt'
})
export class SqrtPipe implements PipeTransform {
    transform(number: number): number {
        let result = 1;
        if (number && number > 0) {
            result = Math.sqrt(number);
            if (number > 2) {
                result *= (1 + (number / 10));
            }
        }
        return result;
    }
}
